var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" 등록된 회사가 없습니다 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }